import Image from 'next/image';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { InputField } from '../../atoms/input-field/InputField';
import { SelectField } from '../../atoms/select-field/SelectField';

export const ValInfo: React.FC<{
  onForward: (data: {
    totalSurface: string;
    floor: string;
    totalFloors: string;
    rooms: string;
    bathrooms: string;
  }) => void;
}> = ({ onForward }) => {
  const { t } = useTranslation(['valutatore']);
  const { t: tc } = useTranslation();
  const [totalSurface, setTotalSurface] = useState<string>('');
  const [floor, setFloor] = useState<string>('');
  const [totalFloors, setTotalFloors] = useState<string>('');
  const [rooms, setRooms] = useState<string>('');
  const [bathrooms, setBathrooms] = useState<string>('');

  return (
    <div>
      <div className="valutatore__container__title">
        <Image
          src="/assets/img/valutatore/informazioni.jpg"
          alt="informazioni"
          width={32}
          height={32}
        />
        {t('step_two.title')}
      </div>
      <div className="valutatore__container--two_columns">
        <InputField
          type="number"
          inputMode="numeric"
          name="totalSurface"
          label={t('step_two.area')}
          placeholder={''}
          value={totalSurface}
          onChange={(value) => setTotalSurface(value)}
        />
        <SelectField
          label={t('step_two.floor')}
          options={[
            { label: '', value: '' },
            { label: t('step_two.basement').toString(), value: 'Seminterrato' },
            {
              label: t('step_two.ground_floor').toString(),
              value: 'Piano Terra',
            },
            ...[...Array(6)].map((e, i) => ({
              label: `${i + 1}`,
              value: `${i + 1}`,
            })),
            { label: '6+', value: '6+' },
          ]}
          keyProp={'value'}
          valueProp={'value'}
          textProp={'label'}
          value={floor}
          onChange={(value) => {
            setFloor(value);
          }}
        ></SelectField>
        <InputField
          type="number"
          inputMode="numeric"
          name="total_floors"
          label={t('step_two.total_floors')}
          placeholder={''}
          value={totalFloors}
          onChange={(value) => setTotalFloors(value)}
        />
        <SelectField
          label={t('step_two.rooms')}
          options={[
            { label: '', value: '' },
            ...[...Array(6)].map((e, i) => ({
              label: `${i + 1}`,
              value: `${i + 1}`,
            })),
          ]}
          keyProp={'value'}
          valueProp={'value'}
          textProp={'label'}
          value={rooms}
          onChange={(value) => {
            setRooms(value);
          }}
        ></SelectField>
        <SelectField
          label={t('step_two.bathrooms')}
          options={[
            { label: '', value: '' },
            ...[...Array(6)].map((e, i) => ({
              label: `${i + 1}`,
              value: `${i + 1}`,
            })),
          ]}
          keyProp={'value'}
          valueProp={'value'}
          textProp={'label'}
          value={bathrooms}
          onChange={(value) => {
            setBathrooms(value);
          }}
        ></SelectField>
      </div>
      {!!totalSurface && !!floor && !!totalFloors && !!rooms && !!bathrooms && (
        <div
          className="valutatore__container__button_forward"
          onClick={() =>
            onForward({ totalSurface, floor, totalFloors, rooms, bathrooms })
          }
        >
          {tc('next')}
        </div>
      )}
    </div>
  );
};
